<div class="content">
  <div class="login critical">
    <div class="login-content">
      <section class="result-content text-center">
        <i class="fa fa-exclamation-triangle critical fa-3x"></i>
        <div class="content-info">
          <div class="spacing">
            <p translate>Please confirm to</p>
            <h3 class="critical">{{Status | translate}}</h3>
          </div>
        </div>
      </section>
      <section class="result-content">
        <div class="content-info">
          <ul class="alert alert-warning">
            <li>
              <span class="title">{{'Paired Device' | translate}} : </span>
              <span class="value">{{Name}}</span>
            </li>
            <li>
              <span class="title">{{'PPC Companions' | translate}} : </span>
              <span class="value">{{Companion}}</span>
            </li>
            <li>
              <span class="title">{{'Power Event Notification' | translate}} :</span>
              <span class="value">{{Event | translate}}</span>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <div class="page-content-btn">
      <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger" (click)="confirmComapanionEvent(); closeCompanionConfirmOTP();"></button>
      <button type="button" pButton label="{{'Cancel' | translate}}" class="p-button-secondary" (click)="cancelComapanionEvent()"></button>
    </div>
  </div>
</div>
<app-dialog (connectEvt)="confrimCompanionCode($event);"></app-dialog>
